import React from "react";
import Flagship from "../../core/flagship";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { empty, getFormattedValue } from "../../utils/helpers";
import { Link } from "react-router";
import Proposal from "./Proposal";
import AdvisrIoUpload from "./AdvisrIoUpload";
import Field from "./Field";
import {
  Button,
  Segment,
  Table,
  Loader,
  Header,
  Icon,
  Divider,
  Label,
} from "semantic-ui-react";

class Attachments extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = this.getInitialState();
    this.getProposalUpload = this.getProposalUpload.bind(this);
    this.getIoContent = this.getIoContent.bind(this);
    this.createIo = this.createIo.bind(this);
    this.createRfp = this.createRfp.bind(this);
    this.getDateOfBusinessClosedContent =
      this.getDateOfBusinessClosedContent.bind(this);
  }

  getInitialState() {
    return {
      loading: true,
      data: [],
      businessClosed: !empty(this.props.businessClosed)
        ? this.props.businessClosed
        : "",
    };
  }

  componentDidMount() {
    this.getAttachments();
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.recordId !== nextProps.recordId) {
      this.setState(this.getInitialState(), this.getAttachments);
    }
  }

  getAttachments() {
    let self = this;
    if (this.props.recordType === "io") {
      // Get RFP data for IO

      if (!empty(this.props.parent)) {
        Flagship.get(
          "records-id/" + this.props.parent,
          {},
          function (response) {
            if (response.data.success === true) {
              self.setState({
                data: response.data,
                loading: false,
              });
            } else {
              Flagship.log(
                "error",
                "Error getting RFP data from Flagship API server.",
                self.props.recordId,
                self.props.userId
              );
            }
          },
          function (err) {
            Flagship.log(
              "error",
              "Error getting RFP data from Flagship API server: " + err,
              self.props.recordId,
              self.props.userId
            );
          }
        );
      } 
      this.setState({
        loading: false,
      });
    } else {
      Flagship.get(
        "record-attachments/" +
          this.props.recordType +
          "/" +
          this.props.recordId,
        {},
        function (response) {
          if (response.data.success === true) {
            self.setState({
              data: response.data.results,
              loading: false,
            });
          } else {
            Flagship.log(
              self.props.userId,
              "error",
              "Could not get results from Flagship API server.",
              self.props.recordId
            );
          }
        },
        function (err) {
          console.log("ERR:", err);

          Flagship.log(
            self.props.userId,
            "error",
            "Error getting attachments from Flagship API server: " + err,
            self.props.recordId
          );
        }
      );
    }
  }

  onChangeBusinessClosed(e, data) {
    this.setState({
      businessClosed: data,
    });
  }

  onSaveDateBusinessClosed() {
    if (this.props.accessLevel !== 2) {
      return;
    }

    let self = this;

    Flagship.post(
      "business-closed/" + self.props.recordId,
      {
        closed: self.state.businessClosed,
      },
      function (response) {
        if (response.data.success === true) {
          Flagship.notify("Date saved.", "success");
          Flagship.log(
            "change-business-closed",
            self.state.businessClosed,
            self.props.recordId,
            self.props.userId
          );

          if (
            self.props.recordStatus !== "closed" &&
            self.props.recordStatus !== "insertion"
          ) {
            self.props.onStatusChange(null, { value: "closed" });
          }
        } else {
          Flagship.notify("Date is unchanged.");
        }
      },
      function (err) {
        Flagship.error(
          "Error setting date of business closed: " + err,
          self.props.recordId,
          self.props.userId
        );
      }
    );
  }

  getRecordLink(name, key, type) {
    let icon = "exclamation";
    switch (type) {
      case "client":
        icon = "briefcase";
        break;
      case "rfp":
        icon = "dollar";
        break;
      case "io":
        icon = "rocket";
        break;
      case "line_item":
        icon = "pin";
        break;
    }

    if (type === "rfp" || type === "io") {
      name = "#" + key + " - " + name;
    }
    return (
      <h3 className="attachment-record-link">
        <Icon
          className="feed-icon"
          disabled
          size="large"
          color="grey"
          name={icon}
        />
        <Link to={"/" + type + "/view/" + key}>{name}</Link>
      </h3>
    );
  }

  getRecordStatus(status, type) {

    return (
      <Label
        className={
          "label-hover-" + Flagship.config.records[type].statuses[status].color
        }
      >
        {Flagship.config.records[type].statuses[status].label}
      </Label>
    );
  }

  createIo() {
    if (this.props.accessLevel !== 2) {
      return;
    }

    // Set global state, then redirect to IO creation screen
    Flagship.setFormTemplate(
      {
        extra1: {
          link: "/rfp/view/" + this.props.recordKey,
          key: this.props.recordKey,
          id: this.props.recordId,
          name: this.props.recordName,
          market: this.props.recordMarket,
        },
      },
      function () {
        Flagship.redirect("/io/create");
      }
    );
  }

  createRfp() {
    if (this.props.accessLevel !== 2) {
      return;
    }

    // Set global state, then redirect to IO creation screen
    Flagship.setFormTemplate(
      {
        extra1: {
          link: "/client/view/" + this.props.recordKey,
          key: this.props.recordKey,
          id: this.props.recordId,
          name: this.props.recordName,
        },
      },
      function () {
        Flagship.redirect("/rfp/create");
      }
    );
  }

  getIoContent() {
    let self = this;
    if (!empty(this.state.data.io) && this.state.data.io.length) {
      if (
        this.props.recordType === "rfp" &&
        this.props.recordStatus === "closed"
      ) {
        this.props.onStatusChange(null, { value: "insertion" });
      }

      return (
        <div>
          {this.state.data.io.map(function (item, i) {
            return (
              <Segment
                className="single-record-attachment"
                key={"attachment-io-" + i}
              >
                {self.getRecordLink(item.record_name, item.record_key, "io")}
                <div className="attachment-record-updated">
                  Last Updated: {getFormattedValue(item.updated, "time ago")}
                </div>
                {self.getRecordStatus(item.record_status, "io")}
              </Segment>
            );
          })}

          <Divider hidden />
          {this.props.userRole !== "ae" && this.props.accessLevel === 2 ? (
            <Button
              onClick={self.createIo}
              primary
              content="Create an IO"
              icon="plus"
            />
          ) : null}
          <Divider hidden />
        </div>
      );
    } else {
      return (
        <div>
          <div>No IOs found.</div>
          <Divider hidden />
          {this.props.accessLevel === 2 ? (
            <Button
              onClick={self.createIo}
              primary
              content="Create an IO"
              icon="plus"
            />
          ) : null}
          <Divider hidden />
        </div>
      );
    }
  }

  getDateOfBusinessClosedContent() {
    if (this.props.accessLevel !== 2) {
      return (
        <div className="single-record-single-field">
          <Label>Date Business Closed</Label>
          <div className="field-value">
            {getFormattedValue(this.state.businessClosed, "date")}
          </div>
        </div>
      );
    }

    return (
      <div>
        {this.props.recordStatus === "proposal"
          ? "Enter the date of business closed to begin adding IOs."
          : null}
        <Field
          id="business-closed"
          model="business-closed"
          active="1"
          name="date-business-closed"
          value={this.state.businessClosed}
          onChange={this.onChangeBusinessClosed.bind(this)}
          validation="date"
          type="text"
          minDate="0"
          label="Date Business Closed"
        />
        <Button
          primary
          onClick={this.onSaveDateBusinessClosed.bind(this)}
          content="Save Date"
        />
        <Divider hidden />
      </div>
    );
  }

  getProposalUpload() {
    if (
      this.props.recordType === "rfp" &&
      this.props.recordStatus === "draft"
    ) {
      return <div>Some line items must be added to receive pricing.</div>;
    } else if (
      this.props.recordType === "rfp" &&
      this.props.recordStatus === "publish"
    ) {
      return <div>A proposal can be uploaded once pricing is complete.</div>;
    } else if (
      this.props.recordType === "rfp" &&
      this.props.recordStatus === "dead"
    ) {
      return <div>You can't upload a proposal to a dead RFP.</div>;
    } else {
      return (
        <Proposal
          folder={"proposal/" + this.props.recordKey}
          recordId={this.props.recordId}
          userId={this.props.userId}
          onStatusChange={this.props.onStatusChange}
          recordStatus={this.props.recordStatus}
          recordKey={this.props.recordKey}
          recordType={this.props.recordType}
          hasContract={this.props.hasContract}
        />
      );
    }
  }

  getAdvisrIoUpload() {
    if (this.props.recordType === "io" && this.props.isAdvisr === true) {
      return (
        <AdvisrIoUpload
          folder={"advisrIo/" + this.props.recordKey}
          recordId={this.props.recordId}
          userId={this.props.userId}
          onStatusChange={this.props.onStatusChange}
          recordStatus={this.props.recordStatus}
          recordKey={this.props.recordKey}
          recordType={this.props.recordType}
          hasAdvisrIo={this.props.hasAdvisrIo}
        />
      );
    }
  }

  render() {
    let self = this;

    if (this.state.loading === true) {
      return (
        <Table>
          <Table.Body>
            <Table.Row>
              <Table.Cell colSpan="5">
                <Loader className="flagship-loader" active inline="centered">
                  Loading Attached Records...
                </Loader>
              </Table.Cell>
            </Table.Row>
          </Table.Body>
        </Table>
      );
    } else {
      if (!empty(this.props) && !empty(this.props.recordType)) {
        switch (this.props.recordType) {
          case "client":
            // Load RFPs and IOs

            if (this.props.userRole !== "client_access_only") {
              return (
                <div className="record-data">
                  {this.props.userRole !== "ae" ? (
                    <div>
                      <Divider hidden />
                      <Header as="h3">Related RFPs</Header>
                      <Divider color="gray" />
                      {!empty(this.state.data.rfp) &&
                      this.state.data.rfp.length ? (
                        this.state.data.rfp.map(function (item, i) {
                          return (
                            <Segment
                              className="single-record-attachment"
                              key={"attachment-rfp-" + i}
                            >
                              {self.getRecordLink(
                                item.record_name,
                                item.record_key,
                                "rfp"
                              )}
                              <div className="attachment-record-updated">
                                Last Updated:{" "}
                                {getFormattedValue(item.updated, "time ago")}
                              </div>
                              {self.getRecordStatus(item.record_status, "rfp")}
                            </Segment>
                          );
                        })
                      ) : (
                        <div>No RFPs found.</div>
                      )}
                    </div>
                  ) : null}
                  <Divider hidden />
                  {this.props.accessLevel === 2 ? (
                    this.props.userRole !== "ae" &&
                    (this.props.userMarket === "Chicago" ||
                      this.props.instance === "SHIFT") ? (
                      <Button
                        onClick={self.createRfp}
                        primary
                        content="Create an RFP"
                        icon="plus"
                      />
                    ) : (
                      <small className="gray-text">
                        RFP creation disabled. Please use Advisr.
                      </small>
                    )
                  ) : null}
                  <Divider hidden />
                  <Header as="h3">Related IOs</Header>
                  <Divider color="gray" />
                  {!empty(this.state.data.io) && this.state.data.io.length ? (
                    this.state.data.io.map(function (item, i) {
                      return (
                        <Segment
                          className="single-record-attachment"
                          key={"attachment-io-" + i}
                        >
                          {self.getRecordLink(
                            item.record_name,
                            item.record_key,
                            "io"
                          )}
                          <div className="attachment-record-updated">
                            Last Updated:{" "}
                            {getFormattedValue(item.updated, "time ago")}
                          </div>
                          {self.getRecordStatus(item.record_status, "io")}
                        </Segment>
                      );
                    })
                  ) : (
                    <div>No IOs found.</div>
                  )}
                  {}
                  <Divider hidden />
                </div>
              );
            } else {
              return null;
            }

          case "rfp":
            // Load IOs
            return (
              <div className="record-data">
                {this.props.recordStatus !== "draft" &&
                this.props.userRole !== "ae" ? (
                  <div>
                    <Divider hidden />
                    <Header as="h3">Proposal</Header>
                    <Divider color="gray" />
                    {self.getProposalUpload()}
                  </div>
                ) : null}

                {this.props.recordStatus === "closed" ||
                this.props.recordStatus === "insertion" ? (
                  <div>
                    <Divider hidden />
                    <Header as="h3">Related IOs</Header>
                    <Divider color="gray" />
                    {self.getIoContent()}
                  </div>
                ) : null}

                {(this.props.recordStatus === "proposal" ||
                  this.props.recordStatus === "closed" ||
                  this.props.recordStatus === "insertion") &&
                this.props.userRole !== "ae" ? (
                  <div>
                    <Divider hidden />
                    <Header as="h3">Date of Business Closed</Header>
                    <Divider color="gray" />
                    {self.getDateOfBusinessClosedContent()}
                  </div>
                ) : null}
                <Divider hidden />
                {this.props.userRole === "admin" &&
                this.props.accessLevel === 2 ? (
                  <div>
                    <Label color="red">Admin Only</Label>
                    <div>
                      <Button
                        color="red"
                        style={{ marginTop: "1em" }}
                        icon="cancel"
                        content={"Cancel " + this.props.niceName}
                        onClick={this.props.onCancelRecord}
                      />
                    </div>
                  </div>
                ) : null}
              </div>
            );

          case "io":
            // Load RFP Data
            return (
              <div className="record-data">
                <Divider hidden />
                <Header as="h3">Signed Contract</Header>
                <Divider color="gray" />
                {self.getProposalUpload()}

                <Divider hidden />

                {this.props.isAdvisr === true ? (
                  <div>
                    <Divider hidden />
                    <Header as="h3">Advisr IO Spreadsheet</Header>
                    <Divider color="gray" />
                    {self.getAdvisrIoUpload()}
                  </div>
                ) : null}

                {this.props.userRole === "admin" &&
                this.props.accessLevel === 2 ? (
                  <div>
                    <Label color="red">Admin Only</Label>
                    <div>
                      <Button
                        color="red"
                        style={{ marginTop: "1em" }}
                        icon="cancel"
                        content={"Cancel " + this.props.niceName}
                        onClick={this.props.onCancelRecord}
                      />
                    </div>
                  </div>
                ) : null}
              </div>
            );

          default:
            return null;
        }
      }
      // If not client or RFP, no need to display data.
      return null;
    }
  }
}

Attachments.propTypes = {
  actions: PropTypes.object,
  username: PropTypes.string,
  userRole: PropTypes.string,
  userId: PropTypes.number,
};

function mapStateToProps(state) {
  return {
    username: state.main.username,
    userId: state.main.userId,
    userRole: state.main.userRole,
    userMarket: state.main.userMarket,
    instance: state.main.instance,
    accessLevel: state.main.accessLevel,
  };
}

export default connect(mapStateToProps, null)(Attachments);



// WEBPACK FOOTER //
// ./src/components/misc/Attachments.js